import React, { useEffect, useState } from 'react';
import { SelectProps } from '@material-ui/core/Select';
import { PasslyTextField } from '@app/components';
import { makeStyles, createStyles, Theme } from '@material-ui/core';
import { TranslationsTypes } from '@app/models';
import { useTypedTranslation } from '@app/hooks';
import { useDebounce } from '@app/helpers';
import { useSelector } from 'react-redux';

interface IProps extends SelectProps {
    label?: TranslationsTypes;
    totalCount: number;
    currentCount: number;
    onFormChange?: (e: any) => void;
    onFetch: (countToUse: number, currentOrgId: string, isReset?: boolean) => void;
    reset?: boolean;
}

const useStyles = makeStyles(() =>
    createStyles({
        root: {
            padding: 0
        },
        passlySelect: {
            'div&>div>div>div>div': {
                padding: 0,
                '&>svg': {
                    position: 'absolute',
                    fontSize: 16
                },
                '&:not(:first-of-type)': {
                    paddingLeft: 20
                }
            }
        }
    })
);

export const PasslySelectInfinite = (props: IProps) => {
    const { label, totalCount, currentCount, onFetch, reset } = props;
    const { translation } = useTypedTranslation();
    const classes = useStyles();
    const [scrollTop, setScrollTop] = useState(0);
    const [scrollMax, setScrollMax] = useState(0);
    const debouncedValue = useDebounce(scrollTop, 100);
    const currentOrgId = useSelector((state: any) => state.organizationSelect.selectedOrganization);
    const resetScroll = useSelector((state: any) => state.basic.resetScroll);

    useEffect(() => {
        if (debouncedValue) {
            const hasMore = currentCount < totalCount;
            const isFetchNextData = scrollMax - scrollMax / 5 < scrollTop;

            if (hasMore && isFetchNextData) {
                onFetch(currentCount, currentOrgId);
            }
        }
    }, [debouncedValue]);

    useEffect(() => {
        if (currentOrgId !== undefined || reset) {
            onFetch(0, currentOrgId, true);
        }
    }, [currentOrgId, resetScroll, reset]);

    const loadMoreItems = (e: any) => {
        setScrollTop(e.target.scrollTop);
        setScrollMax(e.target.scrollHeight - e.target.clientHeight);
    };

    return (
        <PasslyTextField
            className={classes.passlySelect}
            select
            onScroll={loadMoreItems}
            fullWidth={props.fullWidth}
            label={translation(label ?? '')}
            SelectProps={{ ...props }}
        >
            {props.children}
        </PasslyTextField>
    );
};
